export function getNodeEnv(): NodeEnvironment {
  return process.env.NODE_ENV
}

export function isDevelopmentEnvironment(): boolean {
  return getNodeEnv() === 'development'
}

export function isProductionEnvironment(): boolean {
  return getNodeEnv() === 'production'
}

export function isTestEnvironment(): boolean {
  return getNodeEnv() === 'test'
}

/**
 * @deprecated
 * Because the circleci config sets NODE_ENV to "staging" for staging, we need to check for that value
 * in a few cases. However, this shouldn't be relied on, as it would be more appropriate to set a
 * variable like REACT_APP_ENVIRONMENT to "staging" in the circleci config and check for that instead.
 * See https://github.com/gremlin/circleci-config/blob/main/webapp/config.yml#L218
 */
export function isStagingEnvironment(): boolean {
  return getNodeEnv() === 'staging'
}
